import { CaseTag } from '@debbie/common/dist/cases/index.js';
import { CaseVoucherSource } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers/index.js';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import X from '../../Icons/X.js';
import { Button, ButtonGroup, Checkbox, Input, SearchInput, Select, } from '../../index.js';
import TagsEditor from '../../TagsEditor.js';
const ShareEditor = (props) => {
    const lang = useSelector((s) => s.lang);
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : undefined;
    const { share, onChange, onDelete } = props;
    const selectedVoucherType = share.toVoucherTypeIds && share.toVoucherTypeIds[1]
        ? voucherTypes?.find((voucherType) => voucherType.voucherTypeId === share.toVoucherTypeIds?.[1])
        : undefined;
    const [moreSettings, setMoreSettings] = useState(!!(share.forceCollectionCommissionBilling ||
        share.toVoucherTypeIds?.length === 2));
    const selectedForceCollectionCommissionBillingVoucherTypeId = voucherTypes?.find((vt) => vt.voucherTypeId ===
        share.forceCollectionCommissionBilling?.voucherTypeId);
    return (React.createElement(ShareStyled, null,
        !props.readOnly && (React.createElement(X, { style: {
                cursor: 'pointer',
                position: 'absolute',
                top: '20px',
                right: '20px',
            }, onClick: () => onDelete() })),
        React.createElement("h4", null, lang.billingModels.categoriesOrTypesFilter),
        React.createElement(ReactSelect, { value: []
                .concat((share.voucherTypeIds || []).map((voucherTypeId) => {
                const voucherType = voucherTypes?.find((v) => v.voucherTypeId === voucherTypeId);
                return {
                    label: (voucherTypeId &&
                        lang.pluralEconomyVoucherTypeLabels[voucherTypeId]) ||
                        voucherType?.label ||
                        voucherTypeId,
                    value: voucherTypeId,
                };
            }))
                .concat((share.categories || []).map((category) => {
                return {
                    label: (category &&
                        lang.economyCategories[category]) ||
                        category,
                    value: category,
                };
            })), isMulti: true, placeholder: lang.billingModels.selectVouchersGroup, classNamePrefix: "select", options: []
                .concat(!share.voucherTypeIds
                ? CaseVoucherCategories.filter((category) => ![VoucherCategory.TRANSACTION].includes(category)).map((category) => ({
                    label: `${lang.billingModels.voucherCategory} - ${lang.economyCategories[category]}`,
                    value: category,
                }))
                : [])
                .concat(!share.categories
                ? (voucherTypes || [])
                    .filter((voucherType) => [
                    VoucherCategory.COST,
                    VoucherCategory.COURTCOST,
                    VoucherCategory.INTEREST,
                    VoucherCategory.PRINCIPAL,
                ].includes(voucherType.category))
                    .map((voucherType) => ({
                    label: `${lang.billingModels.voucherType} - ${lang.pluralEconomyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label}`,
                    value: voucherType.voucherTypeId,
                }))
                : []), onChange: (val) => {
                const isCategories = val &&
                    val[0] &&
                    !!CaseVoucherCategories.find((category) => val[0].value === category);
                onChange({
                    voucherTypeIds: typeof isCategories === 'boolean' && !isCategories
                        ? (val || []).map((v) => v.value)
                        : undefined,
                    categories: isCategories
                        ? (val || []).map((v) => v.value)
                        : undefined,
                });
            }, isDisabled: props.readOnly }),
        React.createElement("br", null),
        React.createElement("h4", null, lang.billingModels.caseTagFilter),
        React.createElement(Select, { onChange: (e) => {
                onChange({
                    caseTag: e.target.value || undefined,
                });
            }, value: share.caseTag, disabled: props.readOnly },
            React.createElement("option", { value: "" }, lang.billingModels.allVouchers),
            React.createElement("option", { value: CaseTag.SURVEILLANCE }, lang.billingModels.caseTagSurveillanceFilter)),
        React.createElement("h4", null, lang.billingModels.voucherTagFilter),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { onClick: () => {
                    onChange({
                        caseVoucherSource: undefined,
                    });
                }, theme: !share.caseVoucherSource ? undefined : 'secondary', size: "mini", disabled: props.readOnly }, lang.billingModels.allVouchers),
            React.createElement(Button, { onClick: () => {
                    onChange({
                        caseVoucherSource: CaseVoucherSource.Creditor,
                    });
                }, theme: share.caseVoucherSource === CaseVoucherSource.Creditor
                    ? undefined
                    : 'secondary', size: "mini", disabled: props.readOnly }, lang.billingModels.imposedByCreditor),
            React.createElement(Button, { onClick: () => {
                    onChange({
                        caseVoucherSource: CaseVoucherSource.Collector,
                    });
                }, theme: share.caseVoucherSource === CaseVoucherSource.Collector
                    ? undefined
                    : 'secondary', size: "mini", disabled: props.readOnly }, lang.billingModels.imposedByCollector)),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("h4", null, lang.billingModels.feeFraction),
        React.createElement(Input, { placeholder: lang.billingModels.feeFractionPlaceholder, type: "number", value: share.feeFraction ? Math.round(share.feeFraction * 10000) / 100 : '', onChange: (e) => {
                const percentage = e.target.value
                    ? parseFloat(e.target.value)
                    : undefined;
                onChange({
                    feeFraction: percentage ? percentage / 100 : undefined,
                });
            }, disabled: props.readOnly }),
        moreSettings ? (React.createElement("div", null,
            React.createElement(SearchInput, { searchAll: (q) => (voucherTypes || [])
                    .filter((_voucherType) => _voucherType.category === VoucherCategory.FEE)
                    .map((_voucherType) => ({
                    heading: lang.economyVoucherTypeLabels[_voucherType.voucherTypeId] ||
                        _voucherType.label,
                    subheading: lang.economyCategories[_voucherType.category],
                    key: _voucherType.voucherTypeId,
                    returnData: _voucherType.voucherTypeId,
                }))
                    .filter((voucherType) => !q ||
                    JSON.stringify(voucherType)
                        .toLocaleLowerCase()
                        .indexOf(q.toLocaleLowerCase()) !== -1), disabled: props.readOnly, onSelect: (voucherTypeId) => onChange({
                    toVoucherTypeIds: [VoucherTypeIds.DEPOSITPAYOUT, voucherTypeId],
                }), static: selectedVoucherType
                    ? lang.economyVoucherTypeLabels[selectedVoucherType.voucherTypeId] || selectedVoucherType.label
                    : undefined, onRemoveStatic: () => onChange({ toVoucherTypeIds: undefined }), searchDelay: 0, forceOpen: true, placeholder: lang.billingModels.selectSeparateFeeVoucherType }),
            React.createElement(Checkbox, { style: { marginTop: '10px' }, checked: !!share.forceCollectionCommissionBilling, onChange: (e) => !props.readOnly &&
                    onChange({
                        forceCollectionCommissionBilling: e.target.checked
                            ? {
                                withCaseTag: null,
                                voucherTypeId: null,
                            }
                            : undefined,
                    }), placeholder: lang.billingModels.forceCollectionCommissionBilling, disabled: props.readOnly }),
            share.forceCollectionCommissionBilling && (React.createElement("div", null,
                React.createElement(TagsEditor, { tags: share.forceCollectionCommissionBilling.withCaseTag
                        ? [
                            {
                                tag: share.forceCollectionCommissionBilling
                                    .withCaseTag,
                            },
                        ]
                        : [], onChange: (tags) => {
                        onChange({
                            forceCollectionCommissionBilling: {
                                ...share.forceCollectionCommissionBilling,
                                withCaseTag: tags[0]?.tag,
                            },
                        });
                    }, availableTags: [CaseTag.SURVEILLANCE], translations: lang.caseTags, single: true, disabled: props.readOnly }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(SearchInput, { searchAll: (q) => (voucherTypes || [])
                        .filter((_voucherType) => _voucherType.category === VoucherCategory.FEE)
                        .map((_voucherType) => ({
                        heading: lang.economyVoucherTypeLabels[_voucherType.voucherTypeId] || _voucherType.label,
                        subheading: lang.economyCategories[_voucherType.category],
                        key: _voucherType.voucherTypeId,
                        returnData: _voucherType.voucherTypeId,
                    }))
                        .filter((voucherType) => !q ||
                        JSON.stringify(voucherType)
                            .toLocaleLowerCase()
                            .indexOf(q.toLocaleLowerCase()) !== -1), disabled: props.readOnly, onSelect: (voucherTypeId) => onChange({
                        forceCollectionCommissionBilling: {
                            ...share.forceCollectionCommissionBilling,
                            voucherTypeId,
                        },
                    }), static: selectedForceCollectionCommissionBillingVoucherTypeId
                        ? lang.economyVoucherTypeLabels[selectedForceCollectionCommissionBillingVoucherTypeId
                            .voucherTypeId] ||
                            selectedForceCollectionCommissionBillingVoucherTypeId.label
                        : undefined, onRemoveStatic: () => onChange({
                        forceCollectionCommissionBilling: {
                            ...share.forceCollectionCommissionBilling,
                            voucherTypeId: null,
                        },
                    }), searchDelay: 0, forceOpen: true, placeholder: lang.billingModels
                        .forceCollectionCommissionBillingVoucherTypeId }))))) : (React.createElement("p", { style: {
                marginBottom: '0px',
            } },
            React.createElement("span", { style: {
                    cursor: 'pointer',
                    textTransform: 'uppercase',
                    color: THEME.COLOR_ACCENT,
                    fontWeight: '900',
                    fontSize: '0.8em',
                    marginBottom: '0px',
                }, onClick: () => setMoreSettings(true) }, lang.billingModels.moreSettings)))));
};
export const ShareStyled = styled.div `
  position: relative;
  background: #ffffff5a;
  border-radius: 3px;
  padding: ${THEME.GRID_SPACING}px;

  h4 {
    margin-top: 0;
  }
`;
export default ShareEditor;
//# sourceMappingURL=ShareEditor.js.map